import React, { useState } from 'react';
// import { useAuthState } from 'react-firebase-hooks/auth';
import { Link, useNavigate } from 'react-router-dom';
// import google from '../../assets/images/google.png';

//*MUI
import Button from '../../SubComponent/Button';
import { makeStyles } from '@mui/styles';

import cssClasses from './SignUp.module.css';

//* import services
import {
  registerWithEmailAndPassword,
  registerStudentInDataBase,
} from '../../services/Auth';

import { successToast, errorToast } from '../../services/Toast';
import { CustomTextInput } from '../../SubComponent/CustomTextInput';
import { Grid, Card, Paper } from '@mui/material';
import loginImage from '../../assets/images/icons/loginImage.png';
import {
  InputTextIsValid,
  isConfirmPasswordFieldValid,
  isEmailValid,
  isPhoneNumberValid,
  passwordIsValid,
} from '../../services/Validations';
import { dismissLoader, presentLoader } from '../../services/loaderService';
import { Box } from '@mui/material';
import { getStudentsData } from '../../services/examsService';

const useStyles = makeStyles((theme) => ({
  ImageStyle: {
    marginRight: '10px',
    marginTop: '3px',
  },
  IconWrapper: {
    textDecoration: 'none',
    color: '#6941C6',
    marginLeft: '3px',
    fontSize: '1.4rem',
    lineHeight: '2rem',
    fontWeight: 500,
  },
  CardGrid: {
    width: '44.4rem',
    height: '57.8rem',
    marginLeft: '1.8rem',
    borderTopLeftRadius: '25px',
    borderBottomLeftRadius: '25px',
  },
}));

export default function SignUp() {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [FullName, setFullName] = useState('');
  const [phoneNumber , setPhoneNumber] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  
  const [buttonSignIn, setButtonSignIn] = useState(false);



  const [SignUpFields, setSignUpFields] = useState({
    FullName: '',
    email: '',
    password: '',
    PhoneNumber:'',
    confirmPassword:'',
  });
  const [SignUpFieldHelperText, setSignUpFieldHelperText] = useState({
    FullName: '',
    email: '',
    password: '',
    PhoneNumber:'',
    confirmPassword:'',
  });

  const KeyPressed = (e) => {
    if (e.key === 'Enter') {
      register();
    }
  };

  const navigate = useNavigate();

  const register = () => {
    let _FullNameValid = InputTextIsValid(SignUpFields.FullName);
    let _emailValid = isEmailValid(SignUpFields.email);
    let _PhoneNumberValid = isPhoneNumberValid(SignUpFields.PhoneNumber);
    let _passwordValid = passwordIsValid(SignUpFields.password);
    let _confirmPassword = isConfirmPasswordFieldValid(SignUpFields.confirmPassword , SignUpFields.password);

    setSignUpFieldHelperText((pre) => {
      pre.FullName = _FullNameValid.helperText;
      pre.email = _emailValid.helperText;
      pre.PhoneNumber = _PhoneNumberValid.helperText;
      pre.password = _passwordValid.helperText;
      pre.confirmPassword = _confirmPassword.helperText;
      return { ...pre };
    });

    presentLoader();

    if (
      _FullNameValid.flag &&
      _emailValid.flag &&
      _PhoneNumberValid.flag &&
      _passwordValid.flag &&
      _confirmPassword.flag &&
      password === confirmPassword
    ) {
      registerWithEmailAndPassword(email, password)
        .then((result) => {
          let uid = result.user.uid;
          let postBody = {
            'Full Name': FullName,
            email,
            phone: phoneNumber,
            profilePicture: '',
            gender: '',
            aadharCard: '',
            Address: '',
            City: '',
            State: '',
            Pincode: '',
            aadharCardFrontPhoto: '',
            aadharCardBackPhoto: '',
          };
          registerStudentInDataBase(uid, postBody)
            .then((res) => {
              getStudentsData().then((resp) => {
                  console.log("Counted")
              }).catch((err) => {
                console.log(err);
              }) 
              successToast('Account created successfully.');
              setButtonSignIn(true);
              navigate('/');
            })
            .catch((err) => {
              console.log(err);
              errorToast(err.toString());
            });
        })
        .catch((err) => {
          console.log(err.code);
          if(err.code === "auth/email-already-in-use") {
            errorToast('Email already exists!')
          } else {
            console.log(err.toString())
            errorToast("Something went wrong! Try Again");
          }
         
        });
      dismissLoader();
    } else {
      dismissLoader();
    }
  };

  const classList = useStyles();

  return (
    <Grid style={{ width: '100%', height: '100%' }} display={'flex'}>
      <Paper sx={{ margin: 'auto' }} className={cssClasses.paperWrapper}>
        <Grid
          container
          spacing={0}
          direction='row'
          alignItems='center'
          justifyContent='center'
          columns={16}
        >
          <Grid item md={8} lg={7.5}>
            <Box className={cssClasses.subContainer} >
            
              <Box className={cssClasses.HeaderTitle} m={"2rem 0"}>Sign up</Box>
          
              <Box height={'auto'} mb={"2rem"}>
                <CustomTextInput
                  name={'Full name'}
                  inputType={'text'}
                  value={SignUpFields.FullName}
                  onChangeValue={(_value) => {
                    let pre = Object.assign({}, SignUpFields);
                    pre.FullName = _value;
                    setSignUpFields({ ...pre });
                    setSignUpFieldHelperText((pre) => {
                      pre.FullName = InputTextIsValid(_value).helperText;
                      setFullName(_value);
                      return { ...pre };
                    })
                  }}
                  helperText={SignUpFieldHelperText.FullName}
                />
              </Box>

      

              <Box height={'auto'} mb={"2rem"}>
                <CustomTextInput
                  name={'Enter your email'}
                  value={SignUpFields.email}
                  inputType={'email'}
                  onChangeValue={(_value) => {
                    let pre = Object.assign({}, SignUpFields);
                    pre.email = _value;
                    setSignUpFields({ ...pre });
                    setSignUpFieldHelperText((pre) => {
                      pre.email = isEmailValid(_value).helperText;
                      setEmail(_value);
                      return { ...pre };
                    })
                  }}
                  helperText={SignUpFieldHelperText.email}
                />
              </Box>

          

              <Box height={'auto'} mb={"2rem"}>
                <CustomTextInput
                  name={'Enter your phone number'}
                  value={SignUpFields.PhoneNumber}
                  inputType={'Phone'}
                  onChangeValue={(_value) => {
                    let pre = Object.assign({}, SignUpFields);
                    pre.PhoneNumber = _value;
                    setSignUpFields({ ...pre });
                    setSignUpFieldHelperText((pre) => {
                      pre.PhoneNumber = isPhoneNumberValid(_value).helperText;
                      setPhoneNumber(_value);
                      return { ...pre };
                    })
                  }}
                  helperText={SignUpFieldHelperText.PhoneNumber}
                />
              </Box>

           

              
              <Box height={'auto'} mb={"2rem"}>
                <CustomTextInput
                  name={'Create your password'}
                  inputType={'password'}
                  value={SignUpFields.password}
                  onChangeValue={(_value) => {
                    let pre = Object.assign({}, SignUpFields);
                    pre.password = _value;
                    setSignUpFields({ ...pre });
                    setSignUpFieldHelperText((pre) => {
                      pre.password = passwordIsValid(_value).helperText;
                      setPassword(_value);
                      return { ...pre };
                    })
                  }}
                  helperText={SignUpFieldHelperText.password}
                />
                
              </Box>
          
              <Box height={'auto'} mb={"2rem"}>
                <CustomTextInput
                  name={'Confirm your password'}
                  inputType={'password'}
                  value={SignUpFields.confirmPassword}
                  onChangeValue={(_value) => {
                    let pre = Object.assign({}, SignUpFields);
                    pre.confirmPassword = _value;
                    setSignUpFields({ ...pre });
                    setSignUpFieldHelperText((pre) => {
                      pre.confirmPassword = isConfirmPasswordFieldValid(_value , SignUpFields.password).helperText;
                      setConfirmPassword(_value);
                      return { ...pre };
                    })
                  }}
                  helperText={SignUpFieldHelperText.confirmPassword}
                />
              </Box>

            

              <Button
                style={{ color: '#ffffff', backgroundColor: '#3C4952' }}
                btnName={'Create account '}
                padding={'1rem 4.75rem'}
                disable={buttonSignIn}
                clicked={() => register()}
                handleKeypress={KeyPressed}
              />
              
            
      
              <Box className={cssClasses.lastDiv} m={"2rem 0"}>
                <Box className={cssClasses.SubTitle}>Already have an account?</Box>
                <Link className={classList.IconWrapper} to='/'>
                  Log in
                </Link>
              </Box>
            </Box>
          </Grid>

          <Grid
            item
            display={{ xs: 'none', sm: 'none', lg: 'block', md: 'block' }}
            sm={8}
            md={8}
            lg={8}
          >
            <div>
              <Card className={classList.CardGrid}>
                <img
                  src={loginImage}
                  alt='colorImage'
                  height='100%'
                  width='100%'
                />
              </Card>
            </div>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
}
